import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ShelterIndexPropTypes } from 'dpl/shared/utils/customPropTypes';
import { isMobileUA } from 'dpl/shared/utils';
import GoogleMapContainer from 'dpl/containers/GoogleMapContainer';
import GoogleMapMarker from 'dpl/components/GoogleMap/GoogleMapMarker';
import { GOOGLE_MAP_IDS } from 'dpl/shared/constants/shared';

const isMobile = isMobileUA();

export default class Map extends Component {
  static propTypes = {
    mapIsLoaded: PropTypes.bool.isRequired,
    onMapLoad: PropTypes.func.isRequired,
    onMapUpdate: PropTypes.func.isRequired,
    onMarkerClick: PropTypes.func.isRequired,
    shelters: PropTypes.arrayOf(PropTypes.shape(ShelterIndexPropTypes))
      .isRequired
  };

  state = {
    shouldUpdateOnMapChange: false
  };

  handleMapUpdate = googleMap => {
    if (this.state.shouldUpdateOnMapChange) {
      this.props.onMapUpdate(googleMap);
    }
  };

  handleMarkerClick = shelterId => {
    this.props.onMarkerClick(shelterId);
  };

  handleTrackChange = e =>
    this.setState({ shouldUpdateOnMapChange: e.target.checked });

  render() {
    const { onMapLoad, mapIsLoaded, shelters } = this.props;

    const { shouldUpdateOnMapChange } = this.state;

    const points = this.props.shelters.map(shelter => ({
      lat: shelter.address.lat,
      lng: shelter.address.lng
    }));

    return (
      <div
        className={classnames('ShelterMap h-100 relative', {
          'ShelterMap--mobile': isMobile
        })}
      >
        <GoogleMapContainer
          id={GOOGLE_MAP_IDS.LEGACY}
          centerOnChange={!shouldUpdateOnMapChange}
          className="ba br2 b--light-gray"
          coordinates={points}
          onMapLoad={onMapLoad}
          onMapUpdate={this.handleMapUpdate}
          zoomable
        >
          {shelters.map(shelter => (
            <GoogleMapMarker
              id={shelter.id}
              key={shelter.id}
              lat={shelter.address.lat}
              lng={shelter.address.lng}
              markerType="pointer"
              title={shelter.name}
              onClick={e => {
                e.stopPropagation();
                this.handleMarkerClick(shelter.id);
              }}
              popup={{
                image: shelter.cover_photo_url,
                title: shelter.name,
                subtitle: shelter.full_address
              }}
            />
          ))}
        </GoogleMapContainer>
        <div
          className={classnames(
            'absolute mt2 ml2 pv2 ph2 top-0 left-0 z-max ba br1 b--light-gray bg-white f2 transition',
            { 'o-0': !mapIsLoaded }
          )}
        >
          <label className="flex items-center">
            <input
              className="ShelterMap__checkbox mh0 mv0 b--black-50"
              onChange={this.handleTrackChange}
              type="checkbox"
              value={this.state.shouldUpdateOnMapChange}
            />
            <span className="ml2">Search as I move in the box</span>
          </label>
        </div>
      </div>
    );
  }
}
